import Vue from "vue";
import Vuex from "vuex";
import { state, getters, actions, mutations } from "./global"
import modules from './modules'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: modules,
  state,
  getters,
  mutations, 
  actions
});
